var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeDimensionsOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0,
    viewBox: "0 0 512 512",
    className: "dailoicon",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, ">", _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M84 69.6 61.7 91.8l350.7 350.6 22-22.1zM259.7 119v82.6l52.8 52.8v-91h48.3c23.4 0 41.7 7.7 55 23 13.6 15.4 20.4 37.6 20.4 66.5 0 29-6.8 51-20.3 66.4a63.5 63.5 0 0 1-22.2 16.3l36.5 36.5a106 106 0 0 0 27.5-22.2c22-24.7 32.9-57 32.9-97s-11-72.3-32.9-97c-21.8-24.6-51.5-37-89-37zM34.5 130.2v42.2h64l-42.2-42.2zm154 0 18.5 18.5v-18.5zM120 194l-56.9 48.3 22.3 30.5c8.3-3.3 18.5-5 30.6-5a56 56 0 0 1 36.2 11c9 7 13.5 16.9 13.5 29.5 0 12.8-4.1 23-12.4 30.5a50.8 50.8 0 0 1-34.7 11c-11.6 0-22.8-2-33.6-5.7-10.8-4-23.9-10.7-39.2-20L21.3 360c17.9 12 34.4 20.6 49.5 25.6 15.3 5 31.8 7.5 49.4 7.5 29.4 0 52.8-8.4 70.1-25.2a80.3 80.3 0 0 0 24-79.6l-52.6-52.7c-7.7-2.2-15.8-3.8-24.9-4.3l11.1-9.5zm139.7 139.7v53h53z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDimensionsOff);
export default __webpack_public_path__ + "static/media/three-dimensions-off.bec9a7bc6f7968ee91dbf477e0eabd25.svg";
export { ForwardRef as ReactComponent };